<template>
  <pre
    :class="
      cn('group/code bg-primary relative flex max-h-52 flex-col overflow-x-auto rounded-md p-4', props.class)
    "
    dir="ltr"
  >
    <UiButton class="group-hover/code:opacity-100 transition-opacity md:opacity-100 opacity-0 -mt-8 ml-auto -mr-2 z-1 sticky top-0 hover:bg-white/20 p-2 size-8 rounded" variant="ghost" @click="getCode">
      <LucideCheck class="size-6 text-white" v-if="isCopied" />
      <LucideCopy class="size-6 text-white" v-else /> 
    </UiButton>

    <code class="font-mono flex text-xs text-left text-white/80 font-bold" ref="codeEl">
        <slot>{{ code }}</slot>
    </code>
  </pre>
</template>

<script setup lang="ts">
import { LucideCheck, LucideCopy } from "lucide-vue-next"

const props = defineProps<{
  class?: ClassValue
  code?: any
  onCopy?: (content: Nullable<string>) => void
}>()

const codeEl = ref<HTMLElement>()
const clipboard = useClipboard()
const isCopied = ref(false)

const timeout = ref<NodeJS.Timeout>()

onUnmounted(() => {
  clearTimeout(timeout.value)
})

function getCode() {
  const code = codeEl.value?.textContent
  let content = code
  if (!code) return
  try {
    content = JSON.stringify(JSON.parse(code), null, 2)
  } finally {
    isCopied.value = true
    timeout.value = setTimeout(() => {
      isCopied.value = false
    }, 1000)
    clipboard.copy(content || "")
    props.onCopy?.(content)
  }
}
</script>
